import axiosClient from ".";
class TransectionHistory {
  static transections_history(currentPage) {
    return axiosClient.get(`/api/v1/transaction/all?page=${currentPage}`);
  }
}
export default TransectionHistory;
